import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationComponent} from '../component/confirmation/confirmation.component';

@Injectable()
export class ConfirmationService
{

    constructor(private modalService: NgbModal)
    {
    }

    /**
     * Example usage:
     * this.confirmationService.confirm('Save Changes', 'Are you sure you wish to save
     * these changes?')
     *  .then((confirmed) =>
     *  {
     if (confirmed)
     {
     // user clicked ok/save - handle the confirmation event
     }
     else
     {
     // user clicked cancel - no action required
     }

     })
     .catch(() =>
     {
     // user closed the dialogue box or an error occurred while trying to display the
     // dialogue box
     });
     */
    public confirm(
        title: string,
        message: string,
        btnOkText: string = 'OK',
        btnCancelText: string = 'Cancel',
        dialogSize: 'sm' | 'md' | 'lg' = 'sm',
        showOnlyOkBtb = false,
        backdropClass: string = '',
        windowClass: string = ''): Promise<boolean>
    {
        const modalRef = this.modalService.open(ConfirmationComponent, {
            size: dialogSize,
            centered: true,
            backdropClass: backdropClass,
            windowClass: windowClass,
            backdrop: 'static'
        });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;
        modalRef.componentInstance.showOnlyOkBtb = showOnlyOkBtb;

        return modalRef.result;
    }

    public saveConfirmation(
        title: string = '',
        message: string = '',
        btnOkText: string = 'OK',
        btnCancelText: string = 'Cancel',
        dialogSize: 'sm' | 'lg' = 'sm'): Promise<boolean>
    {
        const modalRef = this.modalService.open(ConfirmationComponent, {
            size: dialogSize,
            centered: true
        });
        modalRef.componentInstance.title = `Save changes ${title}`;
        modalRef.componentInstance.message = `Are you sure you wish to save these changes? ${message}`;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;

        return modalRef.result;
    }

    public cancelConfirmation(
        title: string = '',
        message: string = '',
        btnOkText: string = 'OK',
        btnCancelText: string = 'Cancel',
        dialogSize: 'sm' | 'lg' = 'sm'): Promise<boolean>
    {
        const modalRef = this.modalService.open(ConfirmationComponent, {
            size: dialogSize,
            centered: true
        });
        modalRef.componentInstance.title = `Cancel ${title}`;
        modalRef.componentInstance.message = `Are you sure you wish to cancel? ${message}`;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;

        return modalRef.result;
    }
}